import { render, staticRenderFns } from "./shouhuo.vue?vue&type=template&id=0939eea4&"
import script from "./shouhuo.vue?vue&type=script&lang=js&"
export * from "./shouhuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports